/* eslint-disable react/destructuring-assignment */
import * as React from "react";

const TickIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width={21} height={20} fill="none" {...props}>
    <g clipPath="url(#a)">
      <circle cx={10.5} cy={10} r={10} fill="#fff" />
      <path
        fill={props.color || "#10B981"}
        stroke={props.color || "#10B981"}
        strokeWidth={1.25}
        d="m8.435 14.618.446.428.433-.442 7.015-7.16.435-.443-.442-.437-1.185-1.175-.447-.443-.44.45-5.419 5.545-2.12-2.022-.448-.427-.431.444-1.163 1.196-.438.45.454.436 3.75 3.6ZM1.125 10a9.375 9.375 0 1 1 18.75 0 9.375 9.375 0 0 1-18.75 0Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M.5 0h20v20H.5z" />
      </clipPath>
    </defs>
  </svg>
);
export default TickIcon;
